export const visit = (vm, at) => {
vm(require("foundations-components/lang/en.lyaml"));
at({ "en": { "referenceResolversLite": { "owners": { "deactivatedOwner": "(Deactivated/Removed)", "salesforceOwner": "(Salesforce)", "customerAgentsGroup": "Customer Agents", "usersGroup": "Users" }, "conversationInbox": { "archived": "(Archived)" } } } });
};